import React from "react";
import useApi from "./useApi";
import uri from "../utils/uri";


const useVendors = ({ active= false}) => {
    
    const { data: users, isLoading, callApi } = useApi({ url: uri.users.base+'/vendors?'+new URLSearchParams({ active }) }); 
   
    return {
        users, 
        isLoading,
        callApi
    }
}

export default useVendors;